import Tab from "components/Tab";
import ExceptionPropertiesTable from "../../../../contents/docs/error-tracking/_snippets/exception-properties-table.mdx";
import { CalloutBox } from 'components/Docs/CalloutBox';
import BeforeSendHook from "../../../../contents/docs/error-tracking/_snippets/before-send-hook.mdx";
import SuppressionRules from "../../../../contents/docs/error-tracking/_snippets/suppression-rules.mdx";
import BurstProtection from "../../../../contents/docs/error-tracking/_snippets/burst-protection.mdx";
import * as React from 'react';
export default {
  Tab,
  ExceptionPropertiesTable,
  CalloutBox,
  BeforeSendHook,
  SuppressionRules,
  BurstProtection,
  React
};